/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_RemainingInputs */

const vi_order_remaining = /** @type {(inputs: Order_RemainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Còn lại`)
};

/**

* @param {Order_RemainingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_remaining = /** @type {((inputs?: Order_RemainingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_RemainingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_remaining(inputs)
});